export type CsvCell = string | number | null | undefined;

function cell(v: CsvCell): string {
  if (v === null || v === undefined) return '';
  let s: string;
  if (typeof v === 'number') {
    s = String(v); // numbers (including negatives) are never prefixed
  } else {
    // A money amount written as text ("-290.00", always two decimals) is safe and must stay a number for Excel; anything
    // else starting with = + - @ could be read as a formula, so it is defused.
    s = /^-?\d+\.\d{2}$/.test(v) ? v : /^[=+\-@\t\r]/.test(v) ? `'${v}` : v;
  }
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

/** RFC4180 CSV, CRLF line endings, UTF-8 BOM for Excel, formula-injection safe. */
export function toCsv(rows: CsvCell[][]): string {
  return '﻿' + rows.map((r) => r.map(cell).join(',')).join('\r\n');
}

export function downloadCsv(filename: string, rows: CsvCell[][]): void {
  const blob = new Blob([toCsv(rows)], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
